import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import type { CalendarView } from './calendar-types';

interface CalendarPrefs {
  view: CalendarView;
  compact: boolean;
  departments: Record<string, string>;
  setView: (view: CalendarView) => void;
  setCompact: (compact: boolean) => void;
  setDepartment: (branchId: string, departmentId: string) => void;
}

export function restoredDepartment(remembered: Record<string, string>, branchId: string, fallback: string | null | undefined): string {
  return remembered[branchId] ?? fallback ?? '';
}

export const useCalendarPrefs = create<CalendarPrefs>()(
  persist(
    (set) => ({
      view: 'day',
      compact: false,
      departments: {},
      setView: (view) => set({ view }),
      setCompact: (compact) => set({ compact }),
      setDepartment: (branchId, departmentId) => set((state) => ({ departments: { ...state.departments, [branchId]: departmentId } })),
    }),
    { name: 'his.calendar.prefs', storage: createJSONStorage(() => localStorage) },
  ),
);
